import React, {Fragment, useEffect, useState} from "react";
import ReactSelectInput from "../../../../Components/Inputs/ReactSelectInput";
import axios from "axios";
import NumberInput from "../../../../Components/Inputs/NumberInput";
import {useFieldArray} from "react-hook-form";
import AddItemButton from "../../../../Components/Buttons/AddItemButton";

export default function ({register, watch, errors, control, setValue, index}) {
  const {fields, append, remove} = useFieldArray({
    control,
    name: `products.${index}.addresses`,
    keyName: "index",
  });

  const [shopAddresses, setShopAddresses] = useState([]);

  const fetchShopAddresses = (productId) => {
    setShopAddresses([]);
    axios.get(`products/${productId}/shop-addresses`).then(res => {
      if (res.data.status === 'success') {
        setShopAddresses(res.data.productShopAddresses)
      }
    })
  }

  useEffect(() => {
    if (watch(`products.${index}.id`)) {
      fetchShopAddresses(watch(`products.${index}.id`))
    } else {
      setShopAddresses([]);
    }
  }, [JSON.stringify(watch(`products.${index}`)?.id)])

  return (
    <div className="card py-4 mt-3 mb-5 flex-row-fluid">
      <div className="card-header">
        <div className="card-title">
          <h4>Addresses <span className="text-danger fw-bolder fs-6"> *</span></h4>
        </div>
      </div>
      <div className="card-body pt-3">
        {
          fields.map((address, key) => {
            return (
              <Fragment key={address.index}>
                <div className="card border-primary py-4 mt-3 mb-5">
                  <div className="card-body pt-0 pb-0">
                    <div className="row">
                      <div className='w-50'>
                        <ReactSelectInput
                          label='Address'
                          name={`products.${index}.addresses.${key}.shop_address_id`}
                          control={control}
                          errorMessage={errors?.[`products.${index}.addresses.${key}.shop_address_id`]}
                          options={shopAddresses}
                          required={true}
                        />
                      </div>
                      <div className='w-50 number-input-wrapper'>
                        <NumberInput
                          label='Quantity'
                          name={`products.${index}.addresses.${key}.quantity`}
                          register={register}
                          errorMessage={errors?.[`products.${index}.addresses.${key}.quantity`]}
                          required={true}
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => remove(key)}
                      className="btn btn-danger btn-hover-scale btn-sm"
                      disabled={fields.length === 1}
                    >
                      -
                    </button>
                  </div>
                </div>
              </Fragment>
            )
          })
        }
        <AddItemButton title='Add' onClick={() => append({
          shop_address_id: null, quantity: null
        })}/>
      </div>
    </div>
  )
}